import {
  Column,
  Entity,
  Index,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn,
} from "typeorm";
import { AdhocFile } from "./AdhocFile";
import { AdhocProject } from "./AdhocProjects";

@Entity()
@Index(["id", "licenseeName", "status"], { unique: true })
export class AdhocAgreement {
  @PrimaryGeneratedColumn() id: number;

  @Column("varchar") licenseeName: string;

  @Column("varchar") songTitles: string;

  @Column("varchar") useDescription: string;

  @Column("varchar") media: string;

  @Column("varchar") territory: string;

  @Column("varchar") term: string;

  @Column("varchar") licenseFee: string;

  @Column("varchar") proRatedLicenseFee: string;

  @Column("varchar") mfn: string;

  @Column("datetime", { nullable: true }) dateIssued?: Date;

  @Column("varchar") paymentTerm: string;

  @Column("datetime", { nullable: true }) paymentDueDate?: Date;

  @Column("text", { nullable: true }) additionalProvisions?: string;

  @Column("datetime", { nullable: true }) dateExecuted?: Date;

  @Column("datetime", { nullable: true }) datePaid?: Date;

  @Column("varchar") status: string;

  @Column("text", { nullable: true }) notes?: string;

  @ManyToOne(() => AdhocProject, (adhocProject) => adhocProject.adhocAgreements)
  adhocProject?: AdhocProject;

  @OneToMany(() => AdhocFile, (adhocFile) => adhocFile.adhocAgreementId)
  adhocFiles: AdhocFile[];

  @Column("int", { nullable: true }) adhocProjectId?: number;

  assignAttributesFromObject(obj: any) {
    this.id = obj.id !== undefined ? obj.id : this.id;
    this.licenseeName =
      obj.licenseeName !== undefined ? obj.licenseeName : this.licenseeName;
    this.songTitles =
      obj.songTitles !== undefined ? obj.songTitles : this.songTitles;
    this.useDescription =
      obj.useDescription !== undefined
        ? obj.useDescription
        : this.useDescription;
    this.media = obj.media !== undefined ? obj.media : this.media;
    this.territory =
      obj.territory !== undefined ? obj.territory : this.territory;
    this.term = obj.term !== undefined ? obj.term : this.term;
    this.licenseFee =
      obj.licenseFee !== undefined ? obj.licenseFee : this.licenseFee;
    this.proRatedLicenseFee =
      obj.proRatedLicenseFee !== undefined
        ? obj.proRatedLicenseFee
        : this.proRatedLicenseFee;
    this.mfn = obj.mfn !== undefined ? obj.mfn : this.mfn;
    this.dateIssued =
      obj.dateIssued !== undefined ? obj.dateIssued : this.dateIssued;
    this.paymentTerm =
      obj.paymentTerm !== undefined ? obj.paymentTerm : this.paymentTerm;
    this.paymentDueDate =
      obj.paymentDueDate !== undefined
        ? obj.paymentDueDate
        : this.paymentDueDate;
    this.additionalProvisions =
      obj.additionalProvisions !== undefined
        ? obj.additionalProvisions
        : this.additionalProvisions;
    this.dateExecuted =
      obj.dateExecuted !== undefined ? obj.dateExecuted : this.dateExecuted;
    this.datePaid = obj.datePaid !== undefined ? obj.datePaid : this.datePaid;
    this.adhocProjectId =
      obj.adhocProjectId !== undefined
        ? obj.adhocProjectId
        : this.adhocProjectId;
    this.status = obj.status !== undefined ? obj.status : this.status;
    this.notes = obj.notes !== undefined ? obj.notes : this.notes;
  }
}
